@if (isLoading)
{
<div class="dialog-spinner">
  <mat-spinner diameter="40"></mat-spinner>
</div>
}

<div class="wrapper">
  <div class="header">
    <h2 mat-dialog-title>Modeller för {{ machineManufacturerInfo.machineManufacturerName }}</h2>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content class="table-container">
    @if (dataSource) {
    <mat-table [dataSource]="dataSource" class="mat-elevation-8" style="overflow: auto; padding-bottom: 50px;">
      <ng-container matColumnDef="shortName">
        <mat-header-cell *matHeaderCellDef> Förkortning </mat-header-cell>
        <mat-cell *matCellDef="let model"> {{ model.shortName }} </mat-cell>
        <mat-footer-cell *matFooterCellDef>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="newItem.shortName" placeholder="Skriv in unik förkortning">
          </mat-form-field>
        </mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Namn </mat-header-cell>
        <mat-cell *matCellDef="let model; let i = index;">
          <mat-form-field appearance="outline">
            <input matInput type="string" [(ngModel)]="model.name" (ngModelChange)="onInputChange(i)">
          </mat-form-field>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="newItem.name" placeholder="Skriv in namn">
          </mat-form-field>
        </mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="size">
        <mat-header-cell *matHeaderCellDef> Storlek </mat-header-cell>
        <mat-cell *matCellDef="let model; let i = index;">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-select (ngModelChange)="onInputChange(i)" [(ngModel)]="model.size">
              @for(size of machineSizeEnum; track size)
              {
              <mat-option [value]="size">{{machineSizeLabels[size]}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-cell>
        <mat-footer-cell *matFooterCellDef>
          <mat-form-field appearance="outline" floatLabel="always">

            <mat-select [(ngModel)]="newItem.size">
              @for(size of machineSizeEnum; track size)
              {
              <mat-option [value]="size">{{machineSizeLabels[size]}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </mat-footer-cell>
      </ng-container>
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>

        <mat-cell *matCellDef="let element; let i = index;" class="edit-action-buttons-wrapper">
          <button class="add-model-button" mat-raised-button (click)="saveRow(element, i)"
            [disabled]="!isRowModified(i)">Spara</button>
          <button mat-raised-button class="delete-model-button" [disabled]="isModelValueUsed(element)"
            (click)="deleteRow(element)">{{
            isModelValueUsed(element) ? 'Värdet används'
            : 'Ta bort' }}
          </button>
        </mat-cell>

        <mat-footer-cell *matFooterCellDef>
          <button mat-raised-button color="primary" (click)="addItem()" [disabled]="!isValidNewItem()">Lägg
            till</button>
        </mat-footer-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <mat-footer-row *matFooterRowDef="displayedColumns"></mat-footer-row>

    </mat-table>
    }
  </mat-dialog-content>
</div>